// extracted by mini-css-extract-plugin
export var card = "_a5-1";
export var container = "_a5-0";